var _g, _path, _g2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFailedIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_3665_563)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 64,
    cy: 64,
    r: 64,
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3665_563",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 34,
    y: 34,
    width: 61,
    height: 61
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M93.0197 42.5197C94.9722 44.4724 94.9723 47.6382 93.0197 49.5908L78.1104 64.5001L93.0197 79.4094C94.972 81.362 94.972 84.5279 93.0197 86.4805L86.4804 93.0199C84.5278 94.9723 81.3619 94.9722 79.4093 93.0199L64.5 78.1106L49.5907 93.0199C47.6381 94.9722 44.4722 94.9723 42.5196 93.0199L35.9803 86.4805C34.028 84.5279 34.028 81.362 35.9803 79.4094L50.8896 64.5001L35.9803 49.5908C34.0277 47.6382 34.0278 44.4724 35.9803 42.5197L42.5196 35.9804C44.4723 34.0281 47.6382 34.0279 49.5907 35.9804L64.5 50.8897L79.4093 35.9804C81.3618 34.0279 84.5277 34.0281 86.4804 35.9804L93.0197 42.5197Z",
    fill: "#C4C4C4"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3665_563)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M88.0879 119.778C77.1623 129.09 64.3427 134.527 50.4357 137.754C58.1521 124.496 64.9038 107.905 69.8142 90.4385C76.7414 100.926 83.3178 111.027 88.0879 119.778Z",
    fill: "url(#paint0_linear_3665_563)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M88.0872 119.778C83.3171 111.027 76.7407 100.925 69.8135 90.4381C72.4616 80.9856 74.5836 71.2876 76.0392 61.6948C84.0186 77.6711 91.0159 94.0332 96.9785 110.781C94.1901 114.131 91.2088 117.112 88.0872 119.778Z",
    fill: "url(#paint1_linear_3665_563)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.0391 61.6951C74.5835 71.2879 72.4615 80.986 69.8134 90.4385C63.272 80.53 56.3975 70.2883 50.4349 60.4851C55.4505 52.2602 59.8348 44.3334 62.8687 37.1958C67.516 45.2629 71.9003 53.4352 76.0391 61.6951Z",
    fill: "url(#paint2_linear_3665_563)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.436 60.4849C56.3986 70.2881 63.2731 80.5473 69.8145 90.4382C64.9041 107.905 58.1523 124.495 50.436 137.753C42.7196 124.495 35.9678 107.905 31.0575 90.4382C37.5988 80.5298 44.4733 70.2881 50.436 60.4849Z",
    fill: "url(#paint3_linear_3665_563)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.4355 60.4851C44.4729 70.2883 37.5984 80.5475 31.057 90.4385C28.4089 80.986 26.2869 71.2879 24.8314 61.6951C28.9701 53.4352 33.3719 45.2629 38.0193 37.1958C41.0532 44.3334 45.4199 52.2602 50.4355 60.4851Z",
    fill: "url(#paint4_linear_3665_563)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.4353 60.4852C45.4197 52.2603 41.053 44.3336 38.0191 37.196C41.9649 30.3214 46.1212 23.5345 50.4353 16.8003C54.767 23.5345 58.9058 30.3214 62.8691 37.196C59.8352 44.3336 55.4509 52.2603 50.4353 60.4852Z",
    fill: "url(#paint5_linear_3665_563)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7834 119.778C17.5535 111.027 24.1299 100.925 31.057 90.438C35.9674 107.905 42.7192 124.495 50.4355 137.753C36.5286 134.526 23.709 129.09 12.7834 119.778Z",
    fill: "url(#paint6_linear_3665_563)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M118.15 80.105C125.239 93.1468 126.968 102.215 114.85 101.766L89.8096 93.6352C100.277 91.2063 109.927 87.1143 118.15 80.105Z",
    fill: "url(#paint7_linear_3665_563)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M118.152 80.1044C109.929 87.1137 100.279 91.2057 89.8116 93.6346C95.6196 83.6552 100.702 71.1679 104.398 58.0205C109.612 65.9142 114.562 73.5175 118.152 80.1044Z",
    fill: "url(#paint8_linear_3665_563)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M109.082 36.385C107.986 43.6055 106.389 50.9052 104.396 58.0201C99.4723 50.562 94.2978 42.8531 89.8098 35.4742C93.585 29.2833 96.8851 23.3168 99.1687 17.9443C102.667 24.0164 105.967 30.1677 109.082 36.385Z",
    fill: "url(#paint9_linear_3665_563)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M89.8103 35.4741C94.2984 42.853 99.4728 50.5751 104.396 58.02C100.7 71.1674 95.6184 83.6548 89.8103 93.6341C84.0022 83.6548 78.9201 71.1674 75.2241 58.02C80.1478 50.5619 85.3222 42.853 89.8103 35.4741Z",
    fill: "url(#paint10_linear_3665_563)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M89.8105 35.4742C85.3225 42.8531 80.148 50.5752 75.2243 58.0201C73.2311 50.9052 71.6339 43.6055 70.5383 36.385C73.6535 30.1677 76.9668 24.0164 80.4648 17.9443C82.7485 23.3168 86.0353 29.2833 89.8105 35.4742Z",
    fill: "url(#paint11_linear_3665_563)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M89.811 35.4749C86.0357 29.284 82.7489 23.3175 80.4653 17.9451C83.4353 12.7706 86.5638 7.66213 89.811 2.59326C93.0714 7.66213 96.1867 12.7706 99.1699 17.9451C96.8863 23.3175 93.5862 29.284 89.811 35.4749Z",
    fill: "url(#paint12_linear_3665_563)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.5385 36.3853C71.6342 43.6057 73.2314 50.9054 75.2246 58.0203C70.0105 65.914 65.0605 73.5173 61.47 80.1042C59.1204 78.0978 56.8764 75.8538 54.7775 73.3325C59.2656 60.7264 64.5325 48.4106 70.5385 36.3853Z",
    fill: "url(#paint13_linear_3665_563)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.4698 80.1044C65.0602 73.5175 70.0103 65.9142 75.2244 58.0205C78.9204 71.1679 84.0025 83.6552 89.8105 93.6346C79.3428 91.2057 69.6935 87.1137 61.4698 80.1044Z",
    fill: "url(#paint14_linear_3665_563)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.4698 80.105C69.6935 87.1143 79.3428 91.2063 89.8105 93.6352L64.7698 101.766C52.6521 102.215 54.3813 93.1468 61.4698 80.105Z",
    fill: "url(#paint15_linear_3665_563)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.4714 80.1052C54.3829 93.147 52.6537 102.215 64.7715 101.767L44.5092 108.34C47.2813 96.4206 50.7133 84.7648 54.779 73.3335C56.8778 75.8547 59.1218 78.0988 61.4714 80.1052Z",
    fill: "url(#paint16_linear_3665_563)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -7.49414,
    y: -23.7954,
    width: 179.317,
    height: 190.495,
    fill: "#E60000",
    fillOpacity: 0.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_3665_563",
    x: 0,
    y: 0,
    width: 131,
    height: 134,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 3,
    dy: 6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_3665_563"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3665_563",
    x1: 51.9504,
    y1: 136.226,
    x2: 81.4172,
    y2: 95.5464,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE79C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC512",
    stopOpacity: 0.85
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3665_563",
    x1: 97.0626,
    y1: 78.0747,
    x2: 80.6342,
    y2: 120.841,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DF9B12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC551"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3665_563",
    x1: 63.237,
    y1: 37.1958,
    x2: 63.237,
    y2: 90.4385,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1773C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3393E5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3665_563",
    x1: 50.6468,
    y1: 137.791,
    x2: 50.6468,
    y2: 89.8094,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BEDFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3CB4D8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3665_563",
    x1: 37.6335,
    y1: 37.1958,
    x2: 37.6335,
    y2: 90.4385,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1773C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3393E5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3665_563",
    x1: 50.4441,
    y1: 16.8003,
    x2: 50.4441,
    y2: 60.4852,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#123469"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0251CA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_3665_563",
    x1: 46.2131,
    y1: 139.355,
    x2: 25.8732,
    y2: 111.974,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE79C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC512",
    stopOpacity: 0.85
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_3665_563",
    x1: 106.762,
    y1: 80.105,
    x2: 106.762,
    y2: 101.782,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6E01F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_3665_563",
    x1: 90.9517,
    y1: 92.4849,
    x2: 113.131,
    y2: 61.8653,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE79C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC512",
    stopOpacity: 0.85
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_3665_563",
    x1: 99.4459,
    y1: 17.9443,
    x2: 99.4459,
    y2: 58.0201,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1773C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3393E5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_3665_563",
    x1: 89.969,
    y1: 93.6621,
    x2: 89.969,
    y2: 57.5467,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BEDFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3CB4D8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_3665_563",
    x1: 80.1744,
    y1: 17.9443,
    x2: 80.1744,
    y2: 58.0201,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1773C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3393E5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_3665_563",
    x1: 89.8176,
    y1: 2.59326,
    x2: 89.8176,
    y2: 35.4749,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#123469"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0251CA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_3665_563",
    x1: 61.9015,
    y1: 52.8363,
    x2: 65.0011,
    y2: 80.1042,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DF9B12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC34C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_3665_563",
    x1: 86.6323,
    y1: 94.8402,
    x2: 71.3225,
    y2: 74.2309,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE79C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC512",
    stopOpacity: 0.85
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_3665_563",
    x1: 72.8579,
    y1: 80.105,
    x2: 72.8579,
    y2: 101.782,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6E01F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_3665_563",
    x1: 45.4155,
    y1: 108.188,
    x2: 55.2295,
    y2: 72.6614,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE79C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC512",
    stopOpacity: 0.85
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFailedIcon);
export default __webpack_public_path__ + "static/media/failed_icon.ac61da9870cee565efc79ca76c095452.svg";
export { ForwardRef as ReactComponent };